

import React, { useState, createContext } from "react";

export const ArticleSubFamilyContext = createContext();


function ArticleSubFamilyContextComponent(props) {
    const [fsp, setFsp] = useState(
        localStorage.getItem('articleSubFamilyListFSPM') && JSON.parse(localStorage.getItem("articleSubFamilyListFSPM")) ?
            JSON.parse(localStorage.getItem("articleSubFamilyListFSPM")) :
            {
                page: 1, pageSize: 10,
                freeField: "",
                order: null,
                orderBy: null,
                actif: true,
                inactif: false
            })

    return (
        <ArticleSubFamilyContext.Provider
        value={{
            fsp,
            setFsp: (fsp) => {
                setFsp(fsp)
                if (localStorage.getItem('articleSubFamilyListFSPM')) {
                    localStorage.setItem("articleSubFamilyListFSPM", JSON.stringify({ ...JSON.parse(localStorage.getItem("articleSubFamilyListFSPM")), ...fsp }))
                }
                else {
                    localStorage.setItem("articleSubFamilyListFSPM", JSON.stringify({...fsp}))
                }
            }
        }}
        >
            {props.children}
        </ArticleSubFamilyContext.Provider>
    );

}

export default ArticleSubFamilyContextComponent;